import { ReactComponent as BurgerSvg } from '../../assets/icons/burger.svg';

export const BurgerIcon: SvgIcon = (props) => {
    return <BurgerSvg {...props} />;
};
